// "Aircraft details" card of a charter request: the aircraft the user picked.
import { Card, Descriptions } from 'antd';

import type { CharterRequestDetail } from '../../api/types';
import { formatCategory } from '../../data/airportLabel';

export function AircraftDetailsCard({
  r,
}: {
  r: CharterRequestDetail;
}) {
  return (
    <Card title="Aircraft details">
      <Descriptions bordered column={{ xs: 1, sm: 2 }} size="small">
        {/* SHAR-582 — model and tail number are separate fields.
            SHAR-581 — operator and aircraft category were missing entirely. */}
        <Descriptions.Item label="Aircraft model">{r.modelName ?? '—'}</Descriptions.Item>
        <Descriptions.Item label="Tail number">{r.tailNumber ?? '—'}</Descriptions.Item>
        <Descriptions.Item label="Operator">{r.operatorName ?? '—'}</Descriptions.Item>
        <Descriptions.Item label="Aircraft category">{formatCategory(r.category)}</Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
